enum Environment {
    PROD = 'prod',
    STAGE = 'stage',
    DEV = 'dev',
    LOCALHOST = 'localhost',
}

export default Environment;
